import React from 'react';
import { Component } from '@poa/core';
import { observable } from '@poa/state';
import Spinner from 'react-spinkit';

import Navbar from '../components/navbar';
import RouteLoading from '../components/route-loading';
import TableFilter, { PageModeCalendar, DateModeCalendar } from '../components/table-filter';
import CalendarsTableSidebar from '../components/calendar-table/calendars-table-sidebar';
import CalendarsTableHeader from '../components/calendar-table/calendars-table-header';
import CalendarsTable from '../components/calendar-table/calendars-table';
import TD from '../components/calendar-table/calendars-table-datacell';

class CalendarPage2 extends React.Component {
  localState = {
    left: null,
    top: 0,
    loading: false,
    currentPageMode: PageModeCalendar.operators,
    currentDateMode: DateModeCalendar.days,
    data: [],
    expandedRows: []
  };
  store; // injected by Poa
  actions; // injected by Poa
  t; // injected by Poa

  constructor(props) {
    super(props);
    this.localState = observable(JSON.parse(
      (localStorage.getItem(`calendarLocalState_${this.store.auth.currentHost}`))
    ) || this.localState);
    if (this.localState.data.length === 0) {
      this.localState.loading = true;
      this.actions.calendarActions2.fetch(this.localState.currentPageMode);
      this.localState.loading = false;
    }
  }

  onCreateReport = async () => {
    const { startDate, endDate, teamLead } = this.store.calendar.filters;
    this.localState.loading = true;
    this.localState.expandedRows = [];
    try {
      const response = await this.env.api.calendar2.fetchCalendar(
        this.localState.currentPageMode,
        this.localState.currentDateMode,
        startDate.unix(),
        endDate.unix(),
        teamLead
      );
      this.actions.calendarActions2.fetchSuccess(response);
    } catch (e) {
      console.error(e);
      this.actions.calendarActions2.fetchFailed();
      throw e;
    } finally {
      this.localState.loading = false;
      localStorage.setItem(`calendarLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
    }
  };

  onFilterChange = async (user) => {
    this.store.calendar.filters.teamLead = user;
  };

  onPageModeChange = async event => {
    const { startDate, endDate, teamLead } = this.store.calendar.filters;
    this.localState.loading = true;
    this.localState.expandedRows = [];
    switch (event.target.value) {
      case PageModeCalendar.accounts: {
        this.localState.currentPageMode = PageModeCalendar.accounts;
        break;
      }
      case PageModeCalendar.operators: {
        this.localState.currentPageMode = PageModeCalendar.operators;
        break;
      }
      case PageModeCalendar.clients: {
        this.localState.currentPageMode = PageModeCalendar.clients;
        break;
      }
      default:
        console.error('Unknown page type', event.target.value);
        break;
    }

    try {
      const response = await this.env.api.calendar2.fetchCalendar(
        this.localState.currentPageMode,
        this.localState.currentDateMode,
        startDate.unix(),
        endDate.unix(),
        teamLead
      );
      this.actions.calendarActions2.fetchSuccess(response);
    } catch (e) {
      console.error(e);
      this.actions.calendarActions2.fetchFailed();
      throw e;
    } finally {
      this.localState.loading = false;
      localStorage.setItem(`calendarLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
    }
  };

  onDateModeChange = async event => {
    switch (event.target.value) {
      case DateModeCalendar.days: {
        this.localState.currentDateMode = DateModeCalendar.days;
        break;
      }
      case DateModeCalendar.monthes: {
        this.localState.currentDateMode = DateModeCalendar.monthes;
        break;
      }
      default:
        console.error('Unknown date type', event.target.value);
        break;
    }
  };

  handleExpand = async (user) => {
    const { startDate, endDate, teamLead } = this.store.calendar.filters;
    let newExpandedRows = [...this.localState.expandedRows];
    let idxFound = newExpandedRows.findIndex(name => {
      return name === user.name;
    });

    if (idxFound > -1) {
      newExpandedRows.splice(idxFound, 1);
    } else {
      newExpandedRows.push(user.name);
      try {
        const response = await this.env.api.calendar2.fetchCalendarExpandable(
          this.localState.currentPageMode,
          this.localState.currentDateMode,
          startDate.unix(),
          endDate.unix(),
          user.userId,
          teamLead
        );
        this.actions.calendarActions2.fetchExpandableSuccess(response);
      } catch (e) {
        console.error(e);
        this.actions.calendarActions2.fetchFailed();
        throw e;
      }
    }

    this.localState.expandedRows = [...newExpandedRows];
  };

  getRows = (rate, idx) => {
    let rows = [];
    const users = rate.teamLeads || [];

    const firstRow = (

      <React.Fragment key={idx}>
        <tr>
          <th scope='row' className='calendar_type'>
            <button
              className='expand-button'
              style={{ fontWeight: this.localState.expandedRows.includes(rate.name) ? '600' : '300' }}
              onClick={() => this.handleExpand(rate)}
            >
              {rate.name || 'ФИО'} {
                this.localState.currentPageMode !== PageModeCalendar.clients &&
                (<span>({rate.userId})</span>)
                }
            </button>
          </th>
        </tr>
      </React.Fragment>
    );

    rows.push(firstRow);

    if (this.localState.expandedRows.includes(rate.name) && users.length > 0) {
      const userRows = users.map((user, userIdx) => (
        <React.Fragment key={idx + userIdx}>
          <tr>
            <td style={{ textAlign: 'right' }}>
              {user.name}
            </td>
          </tr>
        </React.Fragment>
      ));
      rows.push(userRows);
    }
    return rows;
  };

  getTableRows = rate => {
    let rows = [];
    const users = rate.teamLeads || [];

    const color_rate_active = rate.total >= rate.totalPlan ? 'green' : '#FFAEAC';
    const isNotRowExpanded = this.localState.expandedRows.length === 0;

    const firstRow = (
      <React.Fragment>
        <tr>
          <React.Fragment>
            <TD
              item={{
                amount: rate.total,
                color: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? rate.total === 0 ? '#ccc' : color_rate_active : '#494545',
                backgroundColor: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? '#fff' : '#ecebeb'
              }}
              borderBottom
              borderRight
            />
          </React.Fragment>
          {rate.data.map((d, idx) => (
            <React.Fragment key={idx}>
              <TD
                item={{
                  amount: d.amount,
                  color: d.amount === 0 ? '#ccc' : (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? (d.amount === 0) ? '#ccc' : ((d.amount > d.plan) ? 'green' : '#FFAEAC') : '#494545',
                  size: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? '12px' : '9px',
                  backgroundColor: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? (d.is_weekend) ? 'yellow' : '#fff' : '#e1e1e1'
                }}
                borderBottom
                borderRight
              />
            </React.Fragment>
          ))}
          <React.Fragment>
            <TD
              item={{
                amount: rate.total,
                color: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? rate.total === 0 ? '#ccc' : color_rate_active : '#494545',
                backgroundColor: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? '#fff' : '#ecebeb'
              }}
              borderBottom
              borderRight
            />
          </React.Fragment>
          <React.Fragment>
            <TD
              item={{
                amount: rate.totalPlan,
                backgroundColor: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? '#fff' : '#ecebeb'
              }}
              borderBottom
              borderRight />
          </React.Fragment>
        </tr>
      </React.Fragment>
    );

    rows.push(firstRow);

    if (this.localState.expandedRows.includes(rate.name) && users.length > 0) {
      const userRows = users.map(user => (
        <React.Fragment>
          <tr>
            <React.Fragment>
              <TD
                item={{
                  amount: user.total,
                  color: (user.total >= user.total_plan) ? 'green' : '#FFAEAC',
                  backgroundColor: this.localState.expandedRows.includes(rate.name) ? '#fff' : '#ecebeb'
                }}
                borderBottom
                borderRight />
            </React.Fragment>

            {user.days.map((d, idx) => (
              <React.Fragment key={idx}>
                <TD
                  item={{
                    amount: d.amount,
                    color: d.amount === 0 ? '#ccc' : (d.amount > d.plan) ? 'green' : '#FFAEAC',
                    backgroundColor: '#fff'
                  }}
                  borderBottom
                  borderRight />
              </React.Fragment>
            ))}
            <React.Fragment>
              <TD
                item={{
                  amount: user.total,
                  color: (user.total >= user.total_plan) ? 'green' : '#FFAEAC',
                  backgroundColor: this.localState.expandedRows.includes(rate.name) ? '#fff' : '#ecebeb'
                }}
                borderBottom
                borderRight />
            </React.Fragment>
            <React.Fragment>
              <TD item={{
                amount: user.total_plan,
                backgroundColor: '#fff'
              }} borderBottom borderRight />
            </React.Fragment>

          </tr>
        </React.Fragment>

      ));
      rows.push(userRows);
    }

    return rows;
  };

  getRatesTable = rates => {
    return rates.map((rate, idx) => {
      return this.getTableRows(rate, idx);
    });
  };

  getNameRatesTable = rates => {
    return rates.map((rate, idx) => {
      return this.getRows(rate, idx);
    });
  };


  render() {
    const { selectors, filters } = this.store.calendar;
    const { setDates } = this.actions.calendarActions2;

    return (
      <RouteLoading
        meta={this.store.calendar.meta}
        render={() => {
          return (
            <div className='content'>
              <Navbar />

              <div className='under-navbar-content'>
                <TableFilter
                  withoutFractionalChange
                  withoutStatusChange
                  withoutGroupingChange
                  withoutFilteringChange
                  withSearch={false}
                  withColumnsConfigure={false}
                  getTableNode={() => this.node}
                  state={filters}
                  onDatesChange={setDates}
                  currentPageMode={this.localState.currentPageMode}
                  currentDateMode={this.localState.currentDateMode}
                  onPageModeCalendarChange={this.onPageModeChange}
                  onDateModeCalendarChange={this.onDateModeChange}
                  onFilterCalendarChange={this.onFilterChange}
                  render={() =>
                    <div style={{ verticalAlign: 'middle' }}>
                      <button type='button' className='archive_button' onClick={this.onCreateReport}>
                        ОТЧЁТ
                      </button>
                    </div>
                  }
                />
                <div className='container calendar' style={{ padding: '5px' }}>
                  {this.localState.loading ? (
                    <div className='inner'>
                      <div
                        className='spinner-loading'
                        style={{ paddingTop: '75px', textAlign: 'center' }}
                      >
                        <Spinner name='folding-cube' fadeIn='none' />
                      </div>
                    </div>
                  ) : (
                    <div className='inner' style={{ padding: '5px', display: 'flex' }}>
                      <div>
                        <table>
                          <thead>
                            <tr style={{ maxHeight: '20px', height: '20px', backgroundColor: 'rgb(111, 111, 111)' }}>
                              <th className='empty-first colored'>-</th>
                            </tr>
                            <tr style={{ maxHeight: '20px', height: '20px' }}>
                              <th className='empty-first'>-</th>
                            </tr>
                          </thead>
                        </table>
                        <div
                          style={{
                            width: '200px',
                            height: 'calc(100vh - 243px)',
                            maxHeight: 'calc(100vh - 243px)',
                            overflowY: "hidden"
                          }}
                          ref={node => (this.sidebarEl = node)}
                        >
                          <CalendarsTableSidebar
                            rates={this.getNameRatesTable(selectors.usersData)}
                          />
                        </div>
                      </div>
                      <div>
                        <div
                          style={{ overflowX: 'hidden', width: 'calc(100vw - 280px)' }}
                          ref={node => (this.headerEl = node)}
                        >
                          <table>
                            <CalendarsTableHeader
                              rates={{
                                days: this.localState.currentDateMode === DateModeCalendar.monthes ? selectors.monthToShow : selectors.daysToShow,
                                weekDays: this.localState.currentDateMode === DateModeCalendar.monthes ? selectors.monthNameToShow : selectors.weekDaysToShow,
                                data: selectors.usersData
                              }}
                            />
                          </table>
                        </div>

                        <div
                          className='table-container__body'
                          style={{ width: 'calc(100vw - 280px)', height: 'calc(100vh - 200px)', overflowY: 'scroll', maxHeight: 'calc(100vh - 200px)' }}
                        >
                          <CalendarsTable
                            ref={node => (this.ratesTable = node)}
                            getHeaderElement={() => this.headerEl}
                            getSidebarElement={() => this.sidebarEl}
                            rates={{
                              days: this.localState.currentDateMode === DateModeCalendar.monthes ? selectors.monthToShow : selectors.daysToShow,
                              weekDays: this.localState.currentDateMode === DateModeCalendar.monthes ? selectors.monthNameToShow : selectors.weekDaysToShow,
                              data: this.getRatesTable(selectors.usersData)
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        }}
      />
    );
  }
}

export default Component({ namespaces: ['calendar2'] })(CalendarPage2);
